// TODO: show some sort of UI
export const LoadingState = () => {
  return null;
};
